const LABEL_SET_APPLICATION = {
	experienceNone: 'Noch keine Erfahrung',
	experiencePlaceholder: '- Hast du darin Erfahrung? -',
	selfAssessmentTitle: 'Wie gut kannst du das?',
	selfAssessmentPlaceholder: '- Wie gut kannst du das? -',
	educationNothingAllowed: 'Nein - Ich habe keine Ausbildung dazu',
	educationPlaceholder: '- Hast du dazu auch eine Ausbildung? -',
	requirementPlaceholder: '', // irrelevant, should never be presented for application

	additionExperienceTitle: 'Hast du darin Erfahrung?',
	additionExperienceNone: 'Noch keine Erfahrung',
	additionSelfAssessmentTitle: 'Wie gut kannst du das?',
	additionSelfAssessmentNone: 'Ich kann das noch nicht',
	additionEducationTitle: 'Hast du dazu eine Ausbildung?',
	additionEducationNothingAllowed: 'Nein - Ich habe keine Ausbildung dazu',
};

const LABEL_SET_CUSTOMER = {
	experienceNone: 'Keine Erfahrung nötig',
	experiencePlaceholder: 'Wähle die Mindesterfahrung',
	selfAssessmentTitle: 'Wie gut muss das zumindest beherrscht werden?',
	selfAssessmentPlaceholder: '- Wie gut sollen die Kenntnisse sein? -',
	educationNothingAllowed: 'Es ist keine Ausbildung nötig',
	educationPlaceholder: '- Wird Ausbildung benötigt? -',
	requirementPlaceholder: '- Ist die Erfahrung verpflichtend nötig? -'
};

export function get (labelSet)
{
	return labelSet === 'customer'
		? LABEL_SET_CUSTOMER
		: LABEL_SET_APPLICATION;
}
